import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared';
import { TranslateModuleLoad } from '@app/translate-import';
import { ModelsModule } from '@app/models';
import { ImageModalComponent } from './image-modal.component';

@NgModule({
	imports: [CommonModule, SharedModule, ModelsModule, TranslateModuleLoad()],
	declarations: [ImageModalComponent],
	exports: [ImageModalComponent],
})
export class ImageModalModule {}
